// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eopoi-widget .vueperslide{background-size:cover;background-position:0 0}.eopoi-widget .vueperslide .fullscreen-icon{cursor:pointer;position:absolute;right:5px;bottom:5px;color:#000;border:3px solid #a8c1c7;border-radius:4px;background:#fff}.eopoi-widget .vueperslides__parallax-wrapper{min-height:200px}", ""]);
// Exports
module.exports = exports;
